/* ez-kb-index.js — client search + category filter for the Help Center index
   (sections/ez-kb-index.liquid). Filters guide cards by the active category pill
   and a live title+summary search; collapses empty category groups, keeps the
   per-group count honest, and shows an empty state. Fully defensive. */
(function () {
  'use strict';
  function norm(s) { return (s || '').toLowerCase(); }

  Array.prototype.forEach.call(document.querySelectorAll('.ez-kbx'), function (root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll('.ez-kbx__pill'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.ez-kbx__group'));
    var search = root.querySelector('.ez-kbx__search-input');
    var empty = root.querySelector('[data-kbx-empty]');
    var emptyQ = root.querySelector('[data-kbx-empty-q]');
    if (!groups.length) return;
    var activeCat = 'all';

    function apply() {
      var q = norm(search ? search.value.trim() : '');
      var anyVisible = false;
      groups.forEach(function (g) {
        var catMatch = activeCat === 'all' || activeCat === g.getAttribute('data-cat');
        var shown = 0;
        Array.prototype.forEach.call(g.querySelectorAll('[data-kbx-card]'), function (c) {
          var hay = norm(c.getAttribute('data-title') + ' ' + c.getAttribute('data-dek'));
          var show = catMatch && (!q || hay.indexOf(q) !== -1);
          c.hidden = !show;
          if (show) shown++;
        });
        g.hidden = shown === 0;
        if (shown > 0) anyVisible = true;
        var cnt = g.querySelector('[data-kbx-count]');
        if (cnt) {
          var n = (q || activeCat !== 'all') ? shown : parseInt(cnt.getAttribute('data-full'), 10);
          cnt.textContent = n + (n === 1 ? ' guide' : ' guides');
        }
      });
      if (empty) {
        empty.hidden = anyVisible;
        if (!anyVisible && emptyQ) emptyQ.textContent = q;
      }
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('is-active'); x.removeAttribute('aria-current'); });
        p.classList.add('is-active');
        p.setAttribute('aria-current', 'true');
        activeCat = p.getAttribute('data-cat');
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);
  });
})();
